export default __webpack_public_path__ + "static/char-v-36-ja-154ad05b7a4ec619c8ce2655644da04a.mp4";